// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// DownloadComplianceReportHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import YearTermDTO from '../models/YearTermDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    term: YearTermDTO | null;
    awardTypeIds: number[];
    institutionId: string | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            term: null,
            awardTypeIds: [],
            institutionId: '00000000-0000-0000-0000-000000000000',
        },
        initValues);
    },
    term: 'term',
    awardTypeIds: 'awardTypeIds',
    institutionId: 'institutionId',
}

interface Result extends ResultDTO {
    file: any | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            file: null,
        },
        initValues);
    },
    file: 'file',
}

export { Request, Result };